export default __webpack_public_path__ + "static/media/icon_calendar.6956b88d.svg";